import React from 'react';
import SocialsManager from '../../SocialsManager';

export default function SocialLinksSection({
    onStorefrontChanged,
    wrapperElement = 'section',
}) {
    return (
        <SocialsManager
            onChanged={onStorefrontChanged}
            wrapperElement={wrapperElement}
        />
    );
}
